module.exports = __webpack_public_path__ + "img/3djump200.2110a2ec.png";